import React from "react";
import avatar from "../assets/av.png";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faLaptopCode, faStar } from "@fortawesome/free-solid-svg-icons";

import { Container, Row, Col, Image } from "react-bootstrap";

const Home = () => {
  // Double-click the laptop icon to launch Game Queen.
  const openGameQueen = () => {
    window.open("https://game-queen.fly.dev/", "_blank", "noopener,noreferrer");
  };

  return (
    <Container className="Home" fluid>
      <Row>
        <Col>&nbsp;</Col>
      </Row>
      <Row>
        <Col>
          <Image
            src={avatar}
            className="avatar"
            responsive
            fluid
            roundedCircle
          />
        </Col>
      </Row>
      <Row>
        <Col>&nbsp;</Col>
      </Row>
      <Row>
        <Col>
          <h1>BRETT BARTHOLOMEW</h1>
        </Col>
      </Row>
      <Row>
        <Col>
          <div className="hr-container">
            <div className="hr-line"></div>
            <div
              className="hr-icon"
              onDoubleClick={openGameQueen}
              title="Game Queen"
              style={{ cursor: "pointer" }}
            >
              <FontAwesomeIcon icon={faLaptopCode} />
            </div>
            <div className="hr-line"></div>
          </div>
        </Col>
      </Row>
      <Row>
        <Col>
          <h4>design&nbsp;<FontAwesomeIcon icon={faStar}/>&nbsp;refine&nbsp;<FontAwesomeIcon icon={faStar}/>&nbsp;build</h4>
        </Col>
      </Row>
      <Row>
        <Col>
          <p className="footer-note">
            Looking for Brett Bartholomew, the performance coach &amp; author?{" "}
            <a href="https://brettbartholomew.net" target="_blank" rel="noopener noreferrer">brettbartholomew.net</a>
          </p>
        </Col>
      </Row>
    </Container>
  );
};
export default Home;
